export function downloadFile(data: unknown, fileName: string) {
  const blob = new Blob([data as BlobPart], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const element = document.createElement('a');
  element.href = url;
  element.download = fileName;
  element.click();
  URL.revokeObjectURL(url);
}
